import React, { useState } from "react";

import AboutHeader from "../../components/aboutHeader/aboutHeader";
import Alert from "../../components/alert/alert";
import Footer from "../../components/footer/footer";
import PaymentAccepted from "../../components/paymentAccepted/paymentAccepted";
import { firestore } from "../../db/config";

export default function Contact() {
  const [contactUsDetails, setcontactUsDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });
  const handleDetails = (value, attr) => {
    setcontactUsDetails({
      ...contactUsDetails,
      [attr]: value,
    });
  };
  const [message, setmessage] = useState({
    message: "",
    status: "",
    loader: false,
  });
  const handleSubmit = () => {
    setmessage({
      ...message,
      loader: true,
    });
    if (
      contactUsDetails.firstName === "" ||
      contactUsDetails.lastName === "" ||
      contactUsDetails.message === "" ||
      contactUsDetails.subject === ""
    ) {
      setmessage({
        message: "Please fill out all empty fields.",
        loader: false,
        status: "danger",
      });
      setcontactUsDetails({
        firstName: "",
        lastName: "",
        email: "",
        subject: "",
        message: "",
      });
    } else {
      firestore
        .collection("contactUs")
        .add({ ...contactUsDetails })
        .then((data) => {
          setmessage({
            message: "Message successfully sent.",
            loader: false,
            status: "success",
          });
          setcontactUsDetails({
            firstName: "",
            lastName: "",
            email: "",
            subject: "",
            message: "",
          });
        })
        .catch((error) => {
          setmessage({
            message: error.message,
            loader: false,
            status: "danger",
          });
          setcontactUsDetails({
            firstName: "",
            lastName: "",
            email: "",
            subject: "",
            message: "",
          });
        });
    }
  };
  return (
    <div>
      <AboutHeader />
      <div class="page_title_section">
        <div class="page_header">
          <div class="container">
            <div class="row">
              <div class="col-lg-9 col-md-9 col-12 col-sm-8">
                <h1>contact us</h1>
              </div>
              <div class="col-lg-3 col-md-3 col-12 col-sm-4">
                <div class="sub_title_section">
                  <ul class="sub_title">
                    <li>
                      {" "}
                      <a href="/"> Home </a>&nbsp; / &nbsp;{" "}
                    </li>
                    <li>contact us</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contact_section float_left" style={{ paddingTop: "250px" }}>
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <div style={{ marginBottom: "50px" }}>
                Do you have any questions? We strongly recommend that you start
                searching for the necessary information in the FAQ section. If
                you need advice or technical assistance, do not hesitate to
                contact our specialists. Customer support is available around
                the clock. You just need to send a letter or a request via the
                feedback form to promptly receive the necessary assistance.
                Remember that the more detailed the description of your problem
                is, the sooner it will be solved. Do not forget to indicate your
                login, if you are a registered user of the website.
              </div>
              <div class="sv_heading_wraper heading_wrapper_dark dark_heading">
                <h4> get in touch</h4>
                <h3>contact us for support</h3>
              </div>
            </div>
            <div class="col-lg-10 offset-lg-1 col-md-12 col-sm-12 col-12">
              {message.message ? <Alert details={{ ...message }} /> : ""}
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <div class="form-pos">
                    <div class="form-group i-name">
                      <input
                        type="text"
                        class="form-control require"
                        name="first_name"
                        placeholder="First Name*"
                        onChange={(evt) =>
                          handleDetails(evt.target.value, "firstName")
                        }
                        value={contactUsDetails.firstName}
                      />
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6">
                  <div class="form-pos">
                    <div class="form-group i-name">
                      <input
                        type="text"
                        class="form-control require"
                        name="last_name"
                        placeholder="last Name*"
                        onChange={(evt) =>
                          handleDetails(evt.target.value, "lastName")
                        }
                        value={contactUsDetails.lastName}
                      />
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 col-md-6">
                  <div class="form-e">
                    <div class="form-group i-email">
                      <label class="sr-only">Email </label>
                      <input
                        type="email"
                        class="form-control require"
                        name="email"
                        placeholder=" Email *"
                        data-valid="email"
                        data-error="Email should be valid."
                        onChange={(evt) =>
                          handleDetails(evt.target.value, "email")
                        }
                        value={contactUsDetails.email}
                      />
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 col-md-6">
                  <div class="form-s">
                    <div class="form-group i-subject">
                      <input
                        type="text"
                        class="form-control require"
                        name="subject"
                        placeholder="subject"
                        onChange={(evt) =>
                          handleDetails(evt.target.value, "subject")
                        }
                        value={contactUsDetails.subject}
                      />
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-m">
                    <div class="form-group i-message">
                      <textarea
                        class="form-control require"
                        name="message"
                        rows="5"
                        placeholder=" Message"
                        onChange={(evt) =>
                          handleDetails(evt.target.value, "message")
                        }
                        value={contactUsDetails.message}
                      ></textarea>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="tb_es_btn_div">
                    <div class="response"></div>
                    <div class="tb_es_btn_wrapper conatct_btn2 cont_bnt">
                      <input type="hidden" name="form_type" value="contact" />
                      {message.loader ? (
                        <button type="button" class="submitForm">
                          Please wait...
                        </button>
                      ) : (
                        <button
                          type="button"
                          class="submitForm"
                          onClick={handleSubmit}
                        >
                          send message !
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PaymentAccepted />
      <Footer />
    </div>
  );
}
